import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'network'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      name: this.string(''),
      enabled: this.number(0),
      created_at: this.string(''),
      updated_at: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: process.env.VUE_APP_APIS_FETCHER_ADMIN,
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/networks',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/networks/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/networks',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/networks/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/networks/:id',
          method: 'delete',
        },
      },
    },
  }
}
